/**
 * Invested Line Component
 *
 * Renders the invested amount reference line on the chart.
 */

import { CHART_CONFIG, CHART_COLORS } from "../constants";
import { getChartDimensions, valueToY } from "../utils";

interface InvestedLineProps {
  investedAmount: number;
  min: number;
  max: number;
}

/**
 * Invested amount reference line
 */
export function InvestedLine({ investedAmount, min, max }: InvestedLineProps) {
  const { innerWidth } = getChartDimensions();
  const y = valueToY(investedAmount, min, max);

  // Only show if within visible range
  if (investedAmount < min || investedAmount > max) return null;

  return (
    <g className="invested-line">
      <line
        x1={CHART_CONFIG.paddingLeft}
        y1={y}
        x2={CHART_CONFIG.paddingLeft + innerWidth}
        y2={y}
        stroke={CHART_COLORS.invested.stroke}
        strokeWidth={1.5}
        strokeDasharray={CHART_COLORS.invested.strokeDash}
        strokeOpacity={0.7}
      />
      <text
        x={CHART_CONFIG.paddingLeft + innerWidth + 4}
        y={y}
        dominantBaseline="middle"
        className="fill-amber-600 text-[8px] font-medium"
      >
        Invested
      </text>
    </g>
  );
}
